import type { EdgeId, TerminatedPacketData } from '@ipfabric/utils';
import type { PacketDetail } from 'components/DeviceView/deviceViewTypes';

export const getTerminatedPacketDetail = (
  fakeEdgeId: EdgeId,
  terminatedPacketData: TerminatedPacketData,
): PacketDetail => {
  return {
    id: fakeEdgeId,
    packet: terminatedPacketData.packet,
    showAnimation: true,
    sourceLabel: null,
    targetLabel: null,
  };
};
